import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=6a63b816&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=6a63b816&prod&lang=scss&scoped=true&"
import style1 from "./Header.vue?vue&type=style&index=1&id=6a63b816&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a63b816",
  null
  
)

export default component.exports